<template>
  <div class="i-cell-value">
    <span v-if="publishedAt">
      <a
        @click.prevent="$emit('documentAction', { action: 'liveUri', document: item })"
        href="#"
        class="ac_link_cell i-state-clickable"
        aria-label="Live Uri"
      >
        <i class="fa5 fas fa-external-link fav_icon" name="external-link"></i>
        <span>{{ LANG.viewContent }}</span>
      </a>
    </span>
    <span v-else class="ac_link_cell" aria-label="Not published"
      ><i class="fa5 fas fa-unlink fav_icon" name="unlink"></i>
      <span>{{ LANG.notPublished }}</span>
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  inheritAttrs: false,
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
    publishedAt() {
      return this.item.published_at;
    },
  },
});
</script>
